import { render, staticRenderFns } from "./OwalPanel.vue?vue&type=template&id=36ce2195&scoped=true"
import script from "./OwalPanel.vue?vue&type=script&lang=js"
export * from "./OwalPanel.vue?vue&type=script&lang=js"
import style0 from "./OwalPanel.vue?vue&type=style&index=0&id=36ce2195&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../owal/js/cameras/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ce2195",
  null
  
)

export default component.exports